import { Method_Get_Session_Reports_List, Method_Get_Usage_Reports_List } from "constants/reports";
import NetworkService from "./NetworkService";

class ReportService {
    getLabsReportBySessionList = (urlParams) => {
        return NetworkService.get(`${Method_Get_Session_Reports_List}?${urlParams}`).then((response) => response.data);
    }

    getLabsReportByUsageList = (urlParams) => {
        return NetworkService.get(`${Method_Get_Usage_Reports_List}?${urlParams}`).then((response) => response.data);
    }
}
export default ReportService;